import { map, uniq } from 'lodash';
import ApplicationController from './application_controller';

const CSS_MAP = {
  no_publicar: 'no-publicar',
  tutores_legales: 'tutores-legales',
  alumno: 'alumno',
  ambos: 'ambos',
};

// Botón que al hacer click muestra u oculta los elementos según la selección
/* global $ */
export default class extends ApplicationController {
  connect() {
    this.$element = $(this.element);

    this.$element.find('.boton-seleccionar-todo').on('click', (e) => {
      const $boton = $(e.currentTarget);
      const evaluacionId = $boton.data('evaluacion-id');
      const $botones = this.$element.find(`#tabla-bloqueos-wrapper .change-state-icon[data-evaluacion-id=${evaluacionId}]`);

      // Si están todos marcados, desmarcamos todo, sino marcamos los que no están marcados
      if ($botones.length === $botones.find('.input-seleccion[value=true]').length) {
        // Están todos marcados, desmarcamos todos
        $botones.click();
      } else if ($botones.length === $botones.find('.input-seleccion[value=false]').length) {
        // Están todos desmarcados, marcamos todos
        $botones.click();
      } else {
        // Hay varios marcados y varios sin marcar, marcamos los que no están marcados
        $botones.find('.input-seleccion[value=false]').click();
      }
    });

    /*
    Selecciona todas las evaluaciones de la misma evaluación
    */
    this.$element.find('.dropdown-publicar-todo .publicar-radio-todo').on('change', (e) => {
      const $radio = $(e.currentTarget);
      const valor = $radio.val();
      const evaluacionId = $radio.closest('.dropdown-publicar-todo').data('evaluacion-id');
      this.$element.find(`.dropdown-publicar[data-evaluacion-id="${evaluacionId}"] .publicar-radio`).each((_index, otroRadio) => {
        const $otroRadio = $(otroRadio);
        if ($otroRadio.val() === valor) {
          $otroRadio[0].checked = true;
          $otroRadio[0].dispatchEvent(new Event('change'));
        }
      });
    });

    /*
    Cambia el icono para la evaluación del grupo en el panel de publicaciones
    cuando se selecciona una opción
    */
    this.$element.find('.dropdown-publicar .publicar-radio').on('change', (e) => {
      const $radio = $(e.currentTarget);
      const removeClasses = Object.values(CSS_MAP).join(' ');
      const tipoCss = CSS_MAP[$radio.val()];

      // Tenemos que usar function porque si no no tenemos acceso al puto icono
      // eslint-disable-next-line prefer-arrow-callback
      $radio.closest('.dropdown-publicar').find('i').fadeOut('fast', function onFade() {
        $(this).removeClass(removeClasses).addClass(tipoCss);
      }).fadeIn('fast');
    });

    this.$element.find('.change-state-icon').on('click', (e) => {
      const $button = $(e.currentTarget);
      const $input = $button.find('.input-seleccion');
      const $icon = $button.find('i');
      const valor = $input.val() === 'true' ? 'false' : 'true';

      $input.val(valor);

      if ($icon.is('.fa-lock, .fa-unlock-alt')) {
        $icon.toggleClass('fa-lock fa-unlock-alt');
      }

      $icon.toggleClass('text-danger');
    });

    const tipos = map($('.input-seleccion'), (check) => $(check).data('tipo-grupo'));

    this.$element.find('.filtro-tipo-grupo').toggleClass('hide', uniq(tipos).length < 2);

    this.$element.find("[name='acciones[tipo_grupo]']").on('change', (e) => {
      const $input = $(e.currentTarget);
      this.$element.find(`.fila-grupo-${$input.val()}`).toggle($input.is(':checked'));
    });
  }
}
